import { KoButton, KoDataTableEdit, KoForm, KoNano } from 'packages';
import KoIcon from '@kwapio/icons';
import dayjs from 'dayjs';

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './curd.module.scss';

function SprintLeavePlan({ form, handleFinish, initialValues }) {
  const currentAssignees = useSelector(state => state?.currentAssignees);
  const defaultRow = () => ({
    key: KoNano('SLP'),
    employee: null,
    noOfDays: null,
    fromDate: null,
    endDate: null
  });

  const [dataSource, setDataSource] = useState([defaultRow()]);

  useEffect(() => {
    if (initialValues?.leavePlan?.length > 0) {
      setDataSource(initialValues.leavePlan);
    } else {
      setDataSource([defaultRow()]);
    }
  }, [initialValues]);

  useEffect(() => {
    form.setFieldsValue({
      leavePlan: dataSource
    });
  }, [dataSource, form]);

  const handleDelete = (key) => {
    let newData = dataSource.filter((item) => item.key !== key);
    if (newData.length === 0) {
      newData = [defaultRow()];
    }
    setDataSource(newData);
    HandleSave(newData);
  };


  const columns = [
    {
      dataIndex: 'employee',
      title: 'Employee',
      width: 200,
      editable: true,
      fixed: 'left',
      widget: 'UserSelect',
      options: currentAssignees['data'],
      placeholder: 'Select user'
    },
    {
      dataIndex: 'fromDate',
      title: 'From Date',
      editable: true,
      widget: 'date',
      daysAgo: 0,
      placeholder: 'Select From Date',
      width: 170
    },
    {
      dataIndex: 'endDate',
      title: 'To Date',
      editable: true,
      widget: 'date',
      daysAgo: 0,
      placeholder: 'Select To Date',
      width: 170
    },
    {
      dataIndex: 'noOfDays',
      title: 'No Of Days',
      editable: true,
      widget: 'amount',
      readonly: true,
      width: 100
    },
    {
      title: ` `,
      dataIndex: 'operation',
      width: 40,
      fixed: 'right',
      render: (_, record, i) =>
        dataSource.length >= 1 ? (
          <div className={'editTableCol'}>
            <KoButton
              icon={<KoIcon width={12} height={12} name={'DeleteOutlined'} />}
              className={styles.actionBtn}
              onClick={() => handleDelete(record?.key)}
              label=""
            />
            {dataSource?.length === i + 1 && (
              <KoButton
                icon={<KoIcon color={`var(--palette-gray-7)`} width={17} height={17} name={'PlusOutlined'} />}
                className={styles.actionBtn}
                onClick={handleAdd}
                label={``}
              />
            )}
          </div>
        ) : null
    }
  ];

  const handleAdd = () => {
    const newData = defaultRow();
    setDataSource([...dataSource, newData]);
  };

  const HandleSave = (newData) => {

    newData = newData.map((item) => {
      if (item.fromDate !=='0001-01-01T00:00:00Z' && item.endDate !=='0001-01-01T00:00:00Z') {
        const start = dayjs(item.fromDate).startOf('day');
        const end = dayjs(item.endDate).startOf('day');
        const leaveDays = end.diff(start, 'day') + 1; // +1 to include both start and end dates
        item['noOfDays'] = leaveDays;
      } else {
        item['noOfDays'] = null;
      }
      return item;
    });

    form.setFieldsValue({ leavePlan: newData });
    setDataSource(newData);
  };

  const onRow = (record) => {
  };

  return (
    <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
      <KoForm.Item name={'leavePlan'}>
        <KoDataTableEdit
          dataSource={dataSource}
          form={form}
          onCellClick={onRow}
          onSave={HandleSave}
          defaultColumns={columns}
        />
      </KoForm.Item>
    </KoForm>
  );
}

export default SprintLeavePlan;
